import { render, staticRenderFns } from "./OrganizationFormBlock.vue?vue&type=template&id=62cac0b0&"
import script from "./OrganizationFormBlock.vue?vue&type=script&lang=js&"
export * from "./OrganizationFormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports